<template>
  <div>
    <v-dialog
      v-for="dialog in dialogs"
      :key="dialog.key"
      :value="true"
      :width="dialog.width"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      :persistent="dialog.persistent"
      :retain-focus="false"
      scrollable
      @click:outside="closeOutside(dialog)"
    >
      <v-card>
        <v-card-title class="py-2 px-3 grey lighten-4">
          <v-icon left color="indigo">mdi-account-key-outline</v-icon>
          <span class="text-subtitle-1 font-weight-medium">{{ dialog.title }}</span>
          <v-spacer />
          <v-btn icon @click="close(dialog.key)"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-0">
          <RoutingDroits :editor-params="dialog.params" @title="dialog.title = $event" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import RoutingDroits from './routingDroits.vue'
import { closeRightsEditor, rightsEditorDialogs } from './navigation'

export default {
  name: 'RightsEditorDialogHost',
  components: { RoutingDroits },
  computed: {
    dialogs() {
      return rightsEditorDialogs.items
    },
  },
  methods: {
    close(key) {
      closeRightsEditor(key)
    },
    closeOutside(dialog) {
      if (!dialog.persistent) this.close(dialog.key)
    },
  },
}
</script>
